interface SelectOption {
  value: string
  name: string
}

interface GetSelectCurrentValueParams<T extends SelectOption> {
  currentValue?: T
  options?: T[]
  value?: string
}

export const getSelectCurrentValue = <T extends SelectOption>({
  currentValue,
  options,
  value,
}: GetSelectCurrentValueParams<T>): T | undefined => {
  if (value !== undefined) {
    return options?.find((option) => option.value === value)
  }

  return currentValue
}
